import {OpportunityCard} from '@features/insights/components/opportunity-card'
import {Opportunity} from '@features/insights/types'
import {useTranslation} from '@/translations/i18n'
import {FC, useState} from 'react'
import {ReviewFeedbackModal} from './review-feedback-modal'

interface OpportunitiesProps {
    opportunities: Opportunity[]
}
export const Opportunities: FC<OpportunitiesProps> = ({opportunities}) => {
    const {t} = useTranslation()

    const [selectedOpportunityIndex, setSelectedOpportunityIndex] = useState<number | null>(null)
    const [isOpen, setIsOpen] = useState(false)

    const isPrevDisabled = selectedOpportunityIndex === 0
    const isNextDisabled = selectedOpportunityIndex === opportunities.length - 1

    const handleNext = () => {
        if (!isNextDisabled) {
            setSelectedOpportunityIndex(prevIndex => (prevIndex !== null ? prevIndex + 1 : prevIndex))
        }
    }

    const handlePrev = () => {
        if (!isPrevDisabled) {
            setSelectedOpportunityIndex(prevIndex => (prevIndex !== null ? prevIndex - 1 : prevIndex))
        }
    }

    return (
        <>
            <div className="flex w-full flex-col gap-6 [&_h4]:font-medium [&_h4]:text-xl [&_p]:text-md">
                <div className="flex flex-col gap-1">
                    <h4>{t('insights:issues:title_opportunities')}</h4>
                    <p>{t('insights:issues:description_opportunities')}</p>
                </div>
                <div className="grid w-full grid-cols-1 gap-2 md:grid-cols-3 md:gap-6">
                    {opportunities.map((opportunity, index) => (
                        <OpportunityCard
                            opportunity={opportunity}
                            key={opportunity.id}
                            onClickReviewButton={() => {
                                setIsOpen(true)
                                setSelectedOpportunityIndex(index)
                            }}
                        />
                    ))}
                </div>
            </div>

            <ReviewFeedbackModal
                opportunity={selectedOpportunityIndex !== null ? opportunities[selectedOpportunityIndex] : undefined}
                open={isOpen}
                onOpenChange={open => {
                    setIsOpen(open)
                    if (!open) setSelectedOpportunityIndex(null)
                }}
                onNext={handleNext}
                onPrev={handlePrev}
                isPrevDisabled={isPrevDisabled}
                isNextDisabled={isNextDisabled}
            />
        </>
    )
}
